export default __webpack_public_path__ + "static/media/25083002.c5759bd1.jpg";